import { Guid } from "guid-typescript";
import SubBop from "./SubBop";
import Visa from "./Visa";

export default class Feb {
  public id: string;
  public index: number; 
  public repereEquipements: string;
  public unity: string;
  public unityState: boolean;
  public isPermanent: boolean;
  public workDescription: string;
  public prescriptions: string;
  public niveauPlancherTravail: string;
  public accessNumber: string;
  public chargeSpecifiquePlanchers: string|null;
  public nombrePlancherTravail: string|null;
  public bachageFiletCoupeVent: boolean;
  public bachageIgnifuge: boolean;
  public echafaudageSuspendu: boolean;
  public echafaudageRoulant: boolean;
  public echafaudageInterne: boolean;
  public echafaudageGardeCorps: boolean;
  public echafaudageTypePasserelle: boolean;
  public visas: Array<Visa>;
  public subBops?: SubBop[];
  public dismantleDoneDate: string | null;

  constructor() {
    this.id = Guid.create().toString();
    this.index = 1;
    this.repereEquipements = "";
    this.unity = "";
    this.unityState = true;
    this.isPermanent = false;
    this.workDescription = "";
    this.prescriptions = "";
    this.niveauPlancherTravail = "";
    this.accessNumber = "";
    this.chargeSpecifiquePlanchers = null;
    this.nombrePlancherTravail = null;
    this.bachageFiletCoupeVent = false;
    this.bachageIgnifuge = false;
    this.echafaudageSuspendu = false;
    this.echafaudageRoulant = false;
    this.echafaudageInterne = false;
    this.echafaudageGardeCorps = false;
    this.echafaudageTypePasserelle = false;
    this.dismantleDoneDate = null;
    this.visas = [];
    var firstSubBop = new SubBop();
    firstSubBop.sequenceOrder = 0;
    this.subBops = [firstSubBop];
  }
}
